export default "__VITE_ASSET__Boaz8VsV__"